export const STATUS = {
  OK: 1,
  NG: 0
};
